import React from "react";
import * as PropTypes from "prop-types";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import { useDispatch } from "react-redux";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";

const ErrorModal = ({ errorMessage, handleOk }) => {
  const dispatch = useDispatch();

  const dispatchHandleOk = () => {
    dispatch(handleOk);
  };

  return (
    <Modal
      data-testid="error-modal"
      className="fade-in"
      show
      backdrop="static"
      centered
    >
      <Modal.Header>
        <b>Unexpected error occurred</b>
      </Modal.Header>
      <Modal.Body>{errorMessage}</Modal.Body>
      <Modal.Footer>
        <Button
          data-test="okButton"
          variant={buttonVariants.primary}
          onClick={dispatchHandleOk}
          content="Ok"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;

ErrorModal.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  handleOk: PropTypes.func.isRequired,
};
